export enum StaticElementCanvas {
  line = "line",
  rect = "rect",
  circle = "circle",
  text = "text",
  link = "link",
  image = "image",
}
